import { CircleAIAppShell } from "@circle-react-uikit/CircleAIAppShell";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Skeleton } from "@circleco/compass/components/Skeleton";

import { t } from "@/i18n-js/instance";
import { useIsMobileShellEnabled } from "@/react/components/Mobile/hooks/useIsMobileShellEnabled";

import { ReportSkeleton } from "./ReportSkeleton";

interface AnalyticsReportCanvasSkeletonProps {
  onClose: () => void;
}

export const AnalyticsReportCanvasSkeleton = ({
  onClose,
}: AnalyticsReportCanvasSkeletonProps) => {
  const { isCircleV4 } = useCircleV4();
  const isMobileShellEnabled = useIsMobileShellEnabled();

  return (
    <div
      className={classNames(
        "absolute inset-0 z-30 flex min-h-0 flex-col overflow-hidden",
        {
          "bg-primary dark:bg-secondary": isCircleV4 && !isMobileShellEnabled,
          "bg-primary": !isCircleV4,
          "bg-transparent": isMobileShellEnabled,
        },
      )}
    >
      <CircleAIAppShell.Layout.Inset>
        <CircleAIAppShell.Layout.Inset.Header>
          <div className="bg-secondary border-primary flex items-center gap-2 rounded-t-lg border-b px-3 py-2">
            <span className="size-8 shrink-0" aria-hidden />
            <div className="flex flex-1 justify-center">
              <Skeleton className="h-5 w-full max-w-md" />
            </div>
            <IconButton
              icon="cross"
              variant="outline"
              size="sm"
              onClick={onClose}
              aria-label={t("analytics_chart_preview.close")}
            />
          </div>
        </CircleAIAppShell.Layout.Inset.Header>
        <CircleAIAppShell.Layout.Inset.Body>
          <div className="flex-1 overflow-y-auto">
            <div className="mx-auto max-w-3xl p-8">
              <ReportSkeleton />
            </div>
          </div>
        </CircleAIAppShell.Layout.Inset.Body>
      </CircleAIAppShell.Layout.Inset>
    </div>
  );
};
